module.exports = {
  src: __webpack_public_path__ + "assets/images/calendar-plus.b1aedffe6d45f868.svg",
  width: 96,
  height: 97,
  toString: function() { return __webpack_public_path__ + "assets/images/calendar-plus.b1aedffe6d45f868.svg"; }
};